import React, { useRef } from "react";
import { useScrollProgress } from "@tennr/frontend/hooks/useScrollProgress";
import { PressSection } from "@tennr/frontend/sections/PressSection";
import "./AboutInvestorsSection.css";

export const AboutInvestorsSection: React.FC = () => {
  // track press component for animation
  const pressRef = useRef<HTMLDivElement>(null!);
  const { progress: pressProgress } = useScrollProgress({ target: pressRef });

  // investor logos
  const investorLogos = [
    {
      src: "/svg/IVP.svg",
      alt: "IVP",
    },
    {
      src: "/svg/Iconiq.svg",
      alt: "Iconiq",
    },
    {
      src: "/svg/GoogleVentures.svg",
      alt: "Google Ventures",
    },
    {
      src: "/figma/img/investor-a16z.png",
      alt: "Andreessen Horowitz",
    },
    {
      src: "/figma/img/investor-khosla.png",
      alt: "Foundation Capital",
    },
    {
      src: "/figma/img/investor-bessemer.png",
      alt: "Y Combinator",
    },
    {
      src: "/figma/img/investor-lsvp.png",
      alt: "Lightspeed",
    },
  ];

  return (
    <PressSection
      ref={pressRef}
      progress={pressProgress}
      title="OUR INVESTORS"
      subtitle="Backed by the best"
      body="And trusted by top providers nationwide."
      logos={investorLogos}
      animated={false}
      cardVariant="light"
      className="about-investors-section"
    />
  );
};
